import { TUsersStore } from '~/store/users/types.ts';
import { FetchStatus } from '~/store/covenants/types.ts';

export const usersState: TUsersStore = {
  loading: false,
  error: null,
  user: {
    username: '',
  },
  token: '',
  isInitialized: false,
  isAssetManager: false,
  isClientLogin: false,
  isManagerLogin: false,
  supervisorInfo: {
    data: null,
    status: FetchStatus.Idle,
    error: null,
  },
  mfaToken: '',
};
